import { POST_API_PATH, GET_API_PATH } from "../../../constants"
import apiSetting from "../apiSetting"

const getDeliver = async (data) => {
    try {
        const queryParams = new URLSearchParams(data).toString();
        const response = await apiSetting({ method: 'GET', url: `${GET_API_PATH.GET_URL_DELIVER}?${queryParams}`, data: null })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const createDeliver = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_CREATE_DELIVER, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const updateDeliver = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_UPDATE_DELIVER, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const deleteDeliver = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_DELETE_DELIVER, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

const resetPassword = async (data) => {
    try {
        const response = await apiSetting({ method: 'POST', url: POST_API_PATH.POST_URL_RESET_PASSWORD, data: data })
        // console.log(response.data)
        return response
    } catch (e) {
        throw new Error(`網站錯誤 ! -> ${e}`)
    }
}

export { getDeliver, createDeliver, updateDeliver, deleteDeliver, resetPassword } 